import { generator } from  '../event-listener';

export const OnKeyDown = generator('onKeyDown');
export const OnKeyPress = generator('onKeyPress');
export const OnKeyUp = generator('onKeyUp');
